import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import SunLifeQuoteProposalInfoPageStore, {
  SunLifeQuoteProposalInfoPageStoreContext,
  useSunLifeQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/sunLife/pageStore';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import SunLifeQuoteProposalInfoForm from 'components/quote/quote-proposal-info/SunLife';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { getInitialData, flowDelegate, canCompleteStep, onComplete, isActionLoading } =
    useSunLifeQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <SunLifeQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const SunLifeQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new SunLifeQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <SunLifeQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </SunLifeQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default SunLifeQuoteProposalInfoPage;
